export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 80 },
  { key: '2', headerName: 'Name', field: 'name', hide: false, width: 150 },
  { key: '3', headerName: 'Employee Code', field: 'emp_code', hide: false, width: 150 }, 
  { key: '3', headerName: 'Phone No', field: 'phone_no', hide: false, width: 150 }, 
  { key: '4', headerName: 'Outlet Name', field: 'outlet_name', hide: false, width: 200 },
  { key: '5', headerName: 'Type', field: 'definition_name', hide: false, width: 100 },
  { key: '6', headerName: 'Joining Date', field: 'joining_date', hide: false, width: 100 },
  { key: '7', headerName: 'Status', field: 'status', hide: false, width: 200 },
];